<template lang="jade">
transition(appear, name="fade")
	.asw-legend
		
		.bar
			span(:class="['plus','stoked']")|+
			span(:class="['minus','furious']")|-
			.colorBar
		
		.icons
			.icon(v-for="(emoji, i) in this.emojiData", :class="emoji.title")
				.title
					|{{emoji.title}}
				
				.iconImg(v-if="emoji.title === 'furious' ")
					img(src="../../src/assets/icon_furious.svg")
				.iconImg(v-if="emoji.title === 'depressed' ")
					img(src="../../src/assets/icon_depressed.svg")
				.iconImg(v-if="emoji.title === 'worried' ")
					img(src="../../src/assets/icon_worried.svg")
				.iconImg(v-if="emoji.title === 'meh' ")
					img(src="../../src/assets/icon_meh.svg")
				.iconImg(v-if="emoji.title === 'happy' ")
					img(src="../../src/assets/icon_happy.svg")
				.iconImg(v-if="emoji.title === 'stoked' ")
					img(src="../../src/assets/icon_stoked.svg")

</template>
<script>
	//import d3arc from "d3-shape/src/arc";
	
	export default {
		name: "asw-legend",
		props: {
			emojiData: {
				type: Object
			}
		},
		data: () => ({
			
		}),
		computed: {
			
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>
<style lang="scss">
	
	.asw-legend {
		max-height: 130px;
		overflow: hidden;

		@media only screen and (max-width: 500px) {
			max-height: 90px;
		}

		.bar {
			width:90%;
			margin:0 auto;
			position:relative;
			padding-top:20px;

			.minus {
				position:absolute;
				left:5px;
				top:0;
				font-size:1.5em;
			}
			.plus {
				position:absolute;
				right:5px;
				top:0;
				font-size:1.5em;
			}
			.colorBar {
				height:10px;
				width:100%;
				border-radius: 10px 10px 10px 10px;
				background: rgb(201,0,0);
				background: linear-gradient(90deg, rgba(201,0,0,1) 8%, rgba(244,106,0,1) 25%, rgba(74,168,15,1) 41%, rgba(0,131,141,1) 58%, rgba(22,145,219,1) 74%, rgba(213,18,135,1) 92%);
			}
		}
		
		.icons {
			display: flex;
		}
		.icon {
			justify-content: space-around;
			margin:10px;
			width:15%;
			.title {
				text-align: center;
			}
			.iconImg {
				margin:0 auto;
				height:60px;
				width:60px;
				
				img {
					width:100%;
					height:auto;
				}

				@media only screen and (max-width: 500px) {
					width:50%;
					height:50%;
					img {
						width:30px;
						height:30px;
					}
				}
			}
			@media only screen and (max-width: 500px) {
				//width:10%;
				margin:2px;
				overflow: hidden;
				.title {
					// transform: rotate(90deg);
					font-size: 0.7em;
					
				}
			}
		}

		.furious {color:#C90000;}
		.depressed {color:#F46A00;}
		.worried {color:#4AA80F;}
		.meh {color:#00838D;}
		.happy {color:#1691DB;}
		.stoked {color:#D51287;}	
		
	}

</style>


// WEBPACK FOOTER //
// src/components/EmojiLegend.vue